/**
 * In-memory guest PII for the active salon visit.
 * Avoids persisting name/mobile/email/DOB in sessionStorage (XSS / shared-device risk).
 */

const PII_FIELDS = ['mobile', 'name', 'email', 'gender', 'dob', 'age'];

let activeGuestPii = {};

export function setSalonGuestPii(fields = {}) {
  if (!fields || typeof fields !== 'object') return;
  PII_FIELDS.forEach((key) => {
    if (fields[key] !== undefined && fields[key] !== null && String(fields[key]).trim() !== '') {
      activeGuestPii[key] = String(fields[key]);
    }
  });
}

export function getSalonGuestPiiField(key) {
  return activeGuestPii[key] || '';
}

export function getSalonGuestPii() {
  return { ...activeGuestPii };
}

export function clearSalonGuestPii() {
  activeGuestPii = {};
  lastCustomerSnapshot = null;
}

let lastCustomerSnapshot = null;

export function setSalonLastCustomerSnapshot(snapshot) {
  if (!snapshot || typeof snapshot !== 'object') {
    lastCustomerSnapshot = null;
    return;
  }
  lastCustomerSnapshot = { ...snapshot };
}

export function getSalonLastCustomerSnapshot() {
  return lastCustomerSnapshot ? { ...lastCustomerSnapshot } : null;
}

export function clearSalonLastCustomerSnapshot() {
  lastCustomerSnapshot = null;
}

/** Remove legacy sessionStorage PII keys from prior builds. */
export function purgeLegacySalonPiiSessionKeys() {
  const keys = [
    'enterprise_salon_face_mobile',
    'enterprise_salon_face_name',
    'enterprise_salon_face_email',
    'enterprise_salon_face_gender',
    'enterprise_salon_face_dob',
    'enterprise_salon_face_age',
  ];
  try {
    keys.forEach((key) => sessionStorage.removeItem(key));
    const legacyCustomerKeys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('enterprise_salon_last_customer_v1_')) {
        legacyCustomerKeys.push(key);
      }
    }
    legacyCustomerKeys.forEach((key) => sessionStorage.removeItem(key));
    const legacyLocalKeys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith('enterprise_salon_last_customer_v1_')) {
        legacyLocalKeys.push(key);
      }
    }
    legacyLocalKeys.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignore */
  }
}
